module.exports = __webpack_public_path__ + "img/prod-oven.c4806a55.jpg";